import React, { useEffect } from 'react';
import { Button, Grid, Box, CardContent, CardActions, Divider, TextField } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';

import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import Slide from '@material-ui/core/Slide';


//My Components
import SelectMultiple from './multiSelect';


//Redux
import { useDispatch, useSelector } from 'react-redux';
import { uploadImage } from '../redux/actions/user.actions';


const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const useStyles = makeStyles((theme) => ({
 
    input: {
      display: 'none',
    },
  }));

export default function AlertDialogSlide() {
    const classes = useStyles();
    const dispatch = useDispatch();
  const [open, setOpen] = React.useState(false);
  const [admins, setAdmins] = React.useState([]);
  const [loading, setLoading] = React.useState(false);
  const [values, setValues] = React.useState({
      name: '',
      description: '',
      price: '',
      categories: [],
      image_url: '/static/noStore.png'
  });

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setValues({
        name: '',
        description: '',
        price: '',
        categories: [],
        image_url: '/static/noStore.png'
    })
    setOpen(false);
  };

  const handleChange = prop => event => {
    console.log(prop)
    console.log(event)
    setValues({...values, [prop]: event.target.value})
  }

  const handleChangeSelect = prop => event => {
    setValues({...values, [prop]: event })
  }

  const handleUpload = async e => {
    e.preventDefault();
    const formData = new FormData();
    formData.append("file", e.target.files[0]);
    dispatch(uploadImage(formData))
    .then((res) => {
        setValues({...values, image_url: res});
    })
    .catch(err => {
        console.log(err)
    })
  };



  const handleSubmit = () => {

  }





  return (
      <>
       <input
        accept="image/*"
        className={classes.input}
        onChange={handleUpload}
        id="product-button-file"
        multiple
        type="file"
      />
    <div>
              <Button className="text-center" size="small" onClick={handleClickOpen} >Add Collection</Button>
      <Dialog
      fullWidth
        open={open}
        TransitionComponent={Transition}
        keepMounted
        onClose={handleClose}
        aria-labelledby="alert-dialog-slide-title"
        aria-describedby="alert-dialog-slide-description"
        maxWidth="sm"
      >
        <DialogTitle id="alert-dialog-slide-title">{"Add Cash Collection"}</DialogTitle>
        <DialogContent>
        <Grid
          container
          spacing={3}
        >
          <Grid
            item
            lg={6}
            md={6}
            xs={12}
          >
      <Box
        sx={{
          alignItems: 'center',
          display: 'flex',
          flexDirection: 'column'
        }}
      >
    <img
    src={values.image_url}
    width="100%"
    height="220px"
    className="mb-3"
    />
      </Box>
    <Divider />
    <label className="col p-0" htmlFor="product-button-file">
    <CardActions>
        <Button
        color="primary"
        fullWidth
        variant="text"
        component="span"
        className="pb-0"
      >
        Upload Proof/Reference
      </Button>
    </CardActions>
    </label>
          </Grid>
          <Grid
            item
            lg={6}
            md={6}
            xs={12}
          >
       
              <TextField
         label="Ammount"
         size="small"
         margin="dense"
         name="ammount"
         value={values.ammount}
         onChange={handleChange('ammount')}
         required
         fullWidth
         type="number"
         variant="outlined"
         />
           <TextField
                margin="dense"
                fullWidth
                size="small"
                label="Debtor"
                name="refId"
                onChange={handleChange}
                required
                select
                SelectProps={{ native: true }}
                value={values.refId}
                variant="outlined"
              >
                {admins.map((option) => (
                  <option
                    key={option._id}
                    value={option._id}
                  >
                    {option.name}
                  </option>
                ))}
              </TextField>
          </Grid>
          </Grid>

        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} color="primary">
           Cancel
          </Button>
          <Button onClick={handleSubmit} color="primary">
            Create
          </Button>
        </DialogActions>
      </Dialog>
    </div>
    </>
  );
}
